import {
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
  styled,
} from "@mui/material";
import * as React from "react";

interface Props extends MuiTypographyProps {
  ellipsis?: boolean;
}

const EllipsisTypography = styled(MuiTypography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: "100%",
});

const Typography = React.forwardRef(
  (props: Props, ref: React.ForwardedRef<HTMLElement>) => {
    const { ellipsis, ...other } = props;

    return ellipsis ? (
      <EllipsisTypography ref={ref} {...other} />
    ) : (
      <MuiTypography ref={ref} {...other} />
    );
  }
);

export default Typography;
